import { FF } from "./featureFlip";
import power from "@/images/power-bi.svg";

export const getSocialLinks = () => {
  const links = [];

  if (FF.FACEBOOK_AUTH)
    links.push({
      link: "https://www.facebook.com",
      alt: "Facebook",
      provider: "facebook",
    });

  if (FF.GOOGLE_AUTH)
    links.push({
      link: "https://mail.google.com",
      alt: "Gmail",
      provider: "google-oauth2",
    });

  if (FF.X_AUTH)
    links.push({
      link: "https://x.com",
      alt: "X",
      provider: "twitter",
    });

  if (FF.LINKEDIN_AUTH)
    links.push({
      link: "https://www.linkedin.com",
      alt: "Linkedin",
      provider: "linkedin",
    });

  return links;
};

export const getNonAdminLeftSideBar = (role) => {
  const items = [
    {
      key: "dashboard",
      icon: "/assets/sidebar/dashboard.svg",
      url: "/",
    },
    {
      key: "surveys",
      icon: "/assets/sidebar/surveys.svg",
      url: "/surveys",
    },
  ];

  // Use the role parameter directly instead of sessionStorage functions
  const isBusinessRole = role === "business";
  const isNormalRole = role === "normal";

  if (FF.USE_FOCUS_GROUP)
    items.push({
      key: "focusGroup",
      icon: "/assets/sidebar/focus-groups.svg",
      url: "/focus-groups",
    });

  if (isNormalRole && FF.USE_AWARDS)
    items.push({
      key: "awards",
      icon: "/assets/sidebar/awards.svg",
      url: "/awards",
    });


  if (isBusinessRole)
    items.push({
      key: "invoices",
      icon: "/assets/sidebar/surveys.svg",
      url: "/factures",
    });

  if (isBusinessRole && FF.USE_REPORTS) {
    items.push({
      key: "reports",
      icon: "/assets/sidebar/reports.svg",
      url: "/reports",
    });
    items.push({
      key: "biAnalysis",
      icon: power,
      url: "/BI/Dashboard",
    });
  }

  return items;
};

export const filterRoutes = (routes, role) => {
  let clone = [...routes];

  // Use role parameter instead of sessionStorage
  const isBusinessRole = role === "business";

  if (!FF.USE_FOCUS_GROUP)
    clone = clone.filter(
        (route) =>
            route.index ||
            ["/focus-group", "/jitci"].every((rgx) => !route.path?.startsWith(rgx))
    );

  if (!FF.USE_REPORTS)
    clone = clone.filter(
        (route) => route.index || !route.path?.startsWith("/reports")
    );

  if (!FF.USE_AWARDS)
    clone = clone.filter(
        (route) => route.index || !route.path?.startsWith("/awards")
    );

  if (!FF.CREATE_SURVEY_USE_SIMPLIFIED)
    clone = clone.filter((route) => route.path !== "/survey/new/simple");

  if (!FF.USE_EXCLUSIVITY)
    clone = clone.filter((route) => route.path !== "/exclusivity");

  if (!FF.USE_ASSISTANCE && isBusinessRole)
    clone = clone.filter((route) => !route.path?.startsWith("/assistance"));

  return clone;
};

export const filterBusinessHomeStats = (initialStats) => {
  let stats = [...initialStats];
  if (!FF.USE_FOCUS_GROUP)
    stats = stats.filter((stat) => stat.hint !== "focus-group");
  return stats;
};

export const filterBusinessHomeSlides = (initialSlides) => {
  let slides = [...initialSlides];
  if (!FF.USE_FOCUS_GROUP)
    slides = slides.filter((stat) => stat.hint !== "focus-group");

  return slides;
};
